import charLambo from './char-lambo.json';
import cryBear from './cry-bear.json';
import dogWalk from './dog-walk.json';
import monkeyMoney from './monkey-money.json';
import dogWorship from './dog-worship.json';
import tenantDrunk from './tenant-drunk.json';
import tateBeat from './tate-beat.json';
import dogSlap from './dog-slap.json';
import elonMoney from './elon-money.json';
import charRaideTime from './char-raidtime.json';
import trumpHandshake from './trump-handshake.json';
import charThrowCoin from './char-throw-coin.json';
import charGirlSpank from './char-girl-spank.json';
import charRubPepeHead from './char-pepe-rubhead.json';
import charChestTattoo from './char-chest-tattoo.json';
import charEvictionNotice from './char-eviction-notice.json';
import charChokeBlue from './char-choke-blue.json';
import charCoinsCounting from './char-coins-counting.json';

const stickers = [
  { jsonFile: monkeyMoney },
  { jsonFile: charRaideTime },
  { jsonFile: trumpHandshake },
  { jsonFile: cryBear },
  { jsonFile: dogWalk },
  { jsonFile: tenantDrunk },
  { jsonFile: charThrowCoin },
  { jsonFile: dogWorship },
  { jsonFile: charLambo },
  { jsonFile: dogSlap },
  { jsonFile: elonMoney },
  { jsonFile: tateBeat },
  { jsonFile: charGirlSpank },
  { jsonFile: charEvictionNotice },
  { jsonFile: charChestTattoo },
  { jsonFile: charRubPepeHead },
  { jsonFile: charChokeBlue },
  { jsonFile: charCoinsCounting },
];

export default stickers;
